// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gqJs","tabsBox":"styles_tabsBox__xHW4j","createButton":"styles_createButton__cKlGr"};